import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, Input, InputGroupAddon, InputGroupText, Button } from 'reactstrap';

import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupCopy extends MagstimInputGroup {


    constructor() {
        super();

        this.state = {
           buttonDisabled:true
        };
    }

    static getDerivedStateFromProps(props, state) {
        state.buttonDisabled = props.value.length === 0;
        return state;
    }   
      
    render() {

        const placeholder = this.props.title.replace('*', '')

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText>{this.props.title}</InputGroupText>
            </InputGroupAddon>
            <InputGroup size={CurrentTheme().ControlSize}>
                <InputGroupAddon addonType="prepend" className="d-none d-md-block">
                    <InputGroupText>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <Input type={this.props.type} disabled={this.props.disabled} autoComplete={AUTO_COMPLETE_OFF} onFocus={this.onFocus} name={this.props.name} placeholder={placeholder} value={this.props.value} innerRef={this.props.inputRef} onChange={this.props.onChange} />
                <InputGroupAddon addonType="append">
                        <Button color="primary" disabled={this.state.buttonDisabled} size={CurrentTheme().ControlSize} onClick={this.props.onClick}><i className="fas fa-copy"></i></Button>
                </InputGroupAddon>
            </InputGroup>
            </>
        );
    }
}

MagstimInputGroupCopy.propTypes = {
    title: PropTypes.string,
    name:PropTypes.string,
    touched:PropTypes.bool,
    errors:PropTypes.string,
    disabled:PropTypes.bool,
    type:PropTypes.string,
    value:PropTypes.string,
    inputRef:PropTypes.object,
    onChange: PropTypes.func,
};

MagstimInputGroupCopy.defaultProps = {
    title: "",
    name:"",
    touched:false,
    errors:undefined,
    disabled:false,
    type:"text",
    value:"",
    inputRef:undefined,
    onChange:undefined
};

export default MagstimInputGroupCopy